(function GroupReservationnExport($, Adzuki)
{
	"use strict";

	var form = {
		name: 'GroupReservationExport',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}
		location.href = response.data;
	};

	form.load = function load()
	{
		$('#groupreservationexport-group_by').on('change', function toggleFields() {
			if ($('#groupreservationexport-group_by').val() === 'passenger') {
				$('#export-reservation-fields').addClass('hidden');
				$('#export-passenger-fields').removeClass('hidden');
			} else {
				$('#export-passenger-fields').addClass('hidden');
				$('#export-reservation-fields').removeClass('hidden');
			}
		});

		$('#groupreservationexport-group_by').change();
	};

}(jQuery, window.Adzuki || {}));